<template>
    <v-dialog
        :value="isOpen"
        max-width="300px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wybór ilości kopii
                </h1>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    v-model="copiesCount"
                    label="Ilość kopii"
                    type="number"
                    outlined
                    dense
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="onSave"
                >
                    Akceptuj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'CopiesCountDialog',
    props: {
        isOpen: {
            type: Boolean,
        },
    },
    data() {
        return {
            copiesCount: 1,
        }
    },
    methods: {
        onSave() {
            this.$emit('save', this.copiesCount)

            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.copiesCount = 1
            }, 300)

            this.$emit('close')
        },
    },
}
</script>
